import AssignPage   from './assign_page';
import EmptyPage    from '../components/empty_page';
import MessagesPage from './messages_page';
import renderPage   from '../components/render_page';
import Tab          from './tab';


export default {
  path:         '/:businessID/inbox',
  component:    renderPage(EmptyPage),
  name:         'Inbox',
  onlyTab:      true,
  tabComponent: {
    component: Tab,
    name:      'inbox'
  },
  routes: [
    {
      path:         ':conversationID',
      component:    renderPage(MessagesPage, { className: 'messages-page' }),
      name:         'Inbox',
      tabComponent: {
        component: Tab,
        name:      'inbox'
      },
      routes: [
        {
          path:         'assign',
          component:    renderPage(AssignPage),
          name:         'AssignInfo',
          tabComponent: {
            component: Tab,
            name:      'inbox'
          }
        }
      ]
    }
  ]
};
